import React from "react";
import type { LearningModule } from "./types";
import ApiService from "../../_services/ApiService";
import IssueForm from "../shared/IssueForm";

type IssueTabProps = {
  module: LearningModule | null;
  isViewMode: boolean;
};

export default function IssueTab({ module, isViewMode }: IssueTabProps) {
  const moduleId = module?.id;

  if (!moduleId) {
    return (
      <div className="lmb-card" style={{ padding: 32, textAlign: "center", color: "var(--text-muted)" }}>
        Save this module first to issue it to batches.
      </div>
    );
  }

  return (
    <IssueForm
      resourceId={moduleId}
      isViewMode={isViewMode}
      onIssue={(payload) => ApiService.issueToBatches(moduleId, payload)}
      onGetHistory={() => ApiService.getIssueHistory(moduleId)}
      onDelete={(issueId) => ApiService.deleteIssue(moduleId, issueId)}
    />
  );
}
